/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.FilterChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllFilterTypesRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.FilterChirpService',
  rpcName: 'getAllFilterTypes',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA3U8OPlq1lRpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};